import { tokenAuthApiInstance } from 'utils/auth';

import { RELATIONSHIPS } from '../constants';

export const getRelationShips = async (): Promise<string[]> => {
  const response = await tokenAuthApiInstance.authAxios().get(RELATIONSHIPS);
  return response.data;
};
